import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQueryClient } = ReactQueryV5;
import { useMindlerApi } from "api/apiv2";
import { useCallback } from "react";

export const useInvalidateSlots = () => {
  const queryClient = useQueryClient();
  const api = useMindlerApi();

  return useCallback(
    () =>
      queryClient.invalidateQueries(
        api.slots.psychologist.calendar.queryFilter(),
      ),
    [queryClient, api],
  );
};
